/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactTranscriptionSegmentFromJSON(json) {
    return StreemApiArtifactTranscriptionSegmentFromJSONTyped(json, false);
}
export function StreemApiArtifactTranscriptionSegmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'speakerSid': !exists(json, 'speaker_sid') ? undefined : json['speaker_sid'],
        'unknownSpeakerId': !exists(json, 'unknown_speaker_id') ? undefined : json['unknown_speaker_id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'startTimeMs': !exists(json, 'start_time_ms') ? undefined : json['start_time_ms'],
        'endTimeMs': !exists(json, 'end_time_ms') ? undefined : json['end_time_ms'],
    };
}
export function StreemApiArtifactTranscriptionSegmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'speaker_sid': value.speakerSid,
        'unknown_speaker_id': value.unknownSpeakerId,
        'text': value.text,
        'start_time_ms': value.startTimeMs,
        'end_time_ms': value.endTimeMs,
    };
}
//# sourceMappingURL=StreemApiArtifactTranscriptionSegment.js.map